module.exports = __webpack_public_path__ + "img/Enfermeria.3bd84e19.svg";